import React, { useEffect, useState } from "react";
import StudentLayout from "./StudentLayout";
import { useAuth } from "./AuthContext";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "./firebase";
import { MathfieldElement } from "mathlive";
import Latex from "react-latex-next";
import "katex/dist/katex.min.css";
import './StudentDashboard.css';

function StudentDashboard() {
  const [completedSets, setCompletedSets] = useState(0);
const [averageScore, setAverageScore] = useState(0);
  const [isASLevel, setIsASLevel] = useState(false);
  const { currentUser, loading } = useAuth();
  const [bookings, setBookings] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [fiveADay, setFiveADay] = useState([]);
  const [studentAnswers, setStudentAnswers] = useState([]);
  const [feedback, setFeedback] = useState([]);
  const [attempts, setAttempts] = useState([]);
  const [disabled, setDisabled] = useState([]); // to track which fields should be disabled
const [studentProfile, setStudentProfile] = useState(null);
  useEffect(() => {
    if (!customElements.get("math-field")) {
      customElements.define("math-field", MathfieldElement);
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!currentUser) return;
// 🔍 Fetch the full student profile document from Firestore
const studentDocRef = doc(db, "users", currentUser.uid);
const studentSnap = await getDoc(studentDocRef);

if (!studentSnap.exists()) {
  console.warn("No student profile found in Firestore.");
  return;
}

const studentData = studentSnap.data();
// 🔔 Fetch student's upcoming bookings
const bookingsSnap = await getDocs(collection(db, "bookings"));
const allBookings = bookingsSnap.docs
  .map((doc) => ({ id: doc.id, ...doc.data() }))
  .filter((b) => b.studentId === currentUser.uid);

setBookings(allBookings);


const targetGrade = studentData?.targetGrade || "";
const subject = studentData?.subject || "GCSE Maths";
const rawGrade = targetGrade.toLowerCase();
const detectedIsASLevel = rawGrade.includes("as") || rawGrade.includes("a-level");
setIsASLevel(rawGrade.includes("as") || rawGrade.includes("a-level"));






console.log("🎯 targetGrade:", studentData?.targetGrade);
console.log("📚 subject:", subject);
console.log("🧠 isASLevel:", isASLevel);

   const todayKey = `fiveaday-${currentUser.uid}-${new Date().toISOString().split("T")[0]}`;
let saved;
try {
  saved = JSON.parse(localStorage.getItem(todayKey));
} catch (e) {
  console.warn("⚠️ Failed to parse localStorage 5-a-day:", e);
}

if (saved && saved.fiveADay?.length === 5) {
  setFiveADay(saved.fiveADay || []);
  setStudentAnswers(saved.studentAnswers || []);
  setFeedback(saved.feedback || []);
  setAttempts(saved.attempts || []);
  setDisabled(saved.disabled || []);
} else {
  const questionSnap = await getDocs(collection(db, "questions"));
  const allQuestions = questionSnap.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  const filterByLevel = (level) => {
    return allQuestions.filter((q) => {
      const subjectMatch = q.subject === subject;

      if (detectedIsASLevel) {
        return subjectMatch && q.grade === "AS Level";
      }

      const questionGrade = parseInt(q.grade);
      const gradeMatch = !isNaN(questionGrade) && questionGrade === level;
      return subjectMatch && gradeMatch;
    });
  };

  const pickRandom = (arr, n) => {
    const shuffled = [...arr].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, n);
  };

  let five;

  if (detectedIsASLevel) {
    const asQuestions = allQuestions.filter(
      (q) => q.subject === subject && q.grade === "AS Level"
    );
    five = pickRandom(asQuestions, 5);
  } else {
    const gradeLevel = parseInt(targetGrade.match(/\d+/)?.[0] || "4");
    five = [
      ...pickRandom(filterByLevel(gradeLevel - 1), 1),
      ...pickRandom(filterByLevel(gradeLevel), 3),
      ...pickRandom(filterByLevel(gradeLevel + 1), 1),
    ];
  }

  const blankAnswers = Array(five.length).fill("");
  const blankFeedback = Array(five.length).fill("");
  const blankAttempts = Array(five.length).fill(0);
  const blankDisabled = Array(five.length).fill(false);

  setFiveADay(five);
  setStudentAnswers(blankAnswers);
  setFeedback(blankFeedback);
  setAttempts(blankAttempts);
  setDisabled(blankDisabled);

  localStorage.setItem(
    todayKey,
    JSON.stringify({
      fiveADay: five,
      studentAnswers: blankAnswers,
      feedback: blankFeedback,
      attempts: blankAttempts,
      disabled: blankDisabled,
    })
  );
  // 🧠 Update progress stats


}

const completedDays = JSON.parse(localStorage.getItem("completed-days") || "[]");
setCompletedSets(completedDays.length);

// Optional: calculate average score
let correctCount = 0;
let total = 0;

completedDays.forEach((dayKey) => {
  const data = JSON.parse(localStorage.getItem(dayKey));
  data?.feedback?.forEach((f) => {
    total++;
    if (f === "✅ Correct!") correctCount++;
  });
});

const avg = total ? Math.round((correctCount / total) * 100) : 0;
setAverageScore(avg);

       
      }
 

    if (!loading) fetchData();
  }, [currentUser, loading]);

  const updateLocalStorage = (newAnswers, newFeedback, newAttempts, newDisabled) => {
    const todayKey = `fiveaday-${currentUser.uid}-${new Date().toISOString().split("T")[0]}`;
    const saved = JSON.parse(localStorage.getItem(todayKey));
    const updated = {
      ...saved,
      studentAnswers: newAnswers,
      feedback: newFeedback,
      attempts: newAttempts,
      disabled: newDisabled,
    };
    localStorage.setItem(todayKey, JSON.stringify(updated));
  };

  const handleInput = (value, index) => {
    const newAnswers = [...studentAnswers];
    newAnswers[index] = value;
    setStudentAnswers(newAnswers);
    updateLocalStorage(newAnswers, feedback, attempts, disabled);
  };

  const checkAnswer = (index) => {
      const todayKey = `fiveaday-${currentUser.uid}-${new Date().toISOString().split("T")[0]}`;
    const userInput = studentAnswers[index].replace(/\s/g, "");
    const correctList = fiveADay[index].answers || [];
    const isCorrect = correctList.some(
      (ans) => userInput === ans.replace(/\s/g, "")
    );

    const newFeedback = [...feedback];
    const newAttempts = [...attempts];
    const newDisabled = [...disabled]; // track disabled state

    newAttempts[index] += 1;

    if (isCorrect) {
      newFeedback[index] = "✅ Correct!";
      newDisabled[index] = true; // disable input field on correct answer
    } else if (newAttempts[index] >= 3) {
      const answerLatex = correctList[0] || "";
      newFeedback[index] = { type: "incorrect", latex: answerLatex };
      newDisabled[index] = true; // disable input field after 3rd incorrect attempt
    } else {
      newFeedback[index] = `❌ Try again (Attempt ${newAttempts[index]} of 3)`;
    }

    setFeedback(newFeedback);
    setAttempts(newAttempts);
    setDisabled(newDisabled);
    updateLocalStorage(studentAnswers, newFeedback, newAttempts, newDisabled);
    // ✅ If all inputs are disabled, mark the day as completed
if (newDisabled.every((d) => d === true)) {
  const completed = JSON.parse(localStorage.getItem("completed-days") || "[]");
  if (!completed.includes(todayKey)) {
    completed.push(todayKey);
    localStorage.setItem("completed-days", JSON.stringify(completed));

    // ✅ Update completedSets
    setCompletedSets(completed.length);

    // ✅ Recalculate averageScore
    let correctCount = 0;
    let total = 0;

    completed.forEach((dayKey) => {
      const data = JSON.parse(localStorage.getItem(dayKey));
      data?.feedback?.forEach((f) => {
        total++;
        if (f === "✅ Correct!") correctCount++;
      });
    });

    const avg = total ? Math.round((correctCount / total) * 100) : 0;
    setAverageScore(avg);
  }
}

  };
  const [countdown, setCountdown] = useState("");

useEffect(() => {
  const examDate = new Date("2025-11-05T00:00:00");

  const updateCountdown = () => {
    const now = new Date();
    const diff = examDate - now;

    if (diff <= 0) {
      setCountdown("🚀 It's exam day!");
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    setCountdown(`${days} days ${hours} hours ${minutes} minutes ${seconds} seconds to go`);
  };

  updateCountdown(); // initial call
  const timer = setInterval(updateCountdown, 1000);

  return () => clearInterval(timer); // cleanup
}, []);

  const formatDate = (dateStr) => {
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  };
const calculateStreak = () => {
  const completed = JSON.parse(localStorage.getItem("completed-days") || "[]");
  const dates = completed
    .map((key) => key.split("-").slice(-1)[0]) // extract date
    .map((d) => new Date(d));

  dates.sort((a, b) => b - a); // newest first

  let streak = 0;
  let current = new Date();

  for (let i = 0; i < dates.length; i++) {
    const day = new Date(current);
    day.setDate(current.getDate() - i);
    const match = dates.find((d) => d.toDateString() === day.toDateString());
    if (match) streak++;
    else break;
  }
  return streak;
};

  const getCurrentDayAndDate = () => {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const months = [
      "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
    ];
    const today = new Date();
    const day = days[today.getDay()];
    const date = today.getDate();
    const month = months[today.getMonth()];
    const year = today.getFullYear();

    return `${day}, ${date} ${month} ${year}`;
  };

  if (loading) return <div style={styles.loading}>⏳ Loading your dashboard...</div>;
  if (!currentUser) return <div style={styles.loading}>🚫 You must be logged in to view this page.</div>;

  return (
    <StudentLayout>
      <div style={styles.container}>
        <h1 style={styles.welcome}>👋 Welcome back, {currentUser.displayName || "Student"}!</h1>
        <p style={styles.subtext}>Here’s what’s coming up in your learning journey 🚀</p>

        <div style={styles.sections}>
          <div style={styles.card}>
            <h2>📅 Upcoming Lessons</h2>
            {bookings.length === 0 ? (
              <p>No lessons coming up.</p>
            ) : (
             <table style={styles.table}>
  <thead>
    <tr>
      <th style={styles.th}>Date</th>
      <th style={styles.th}>Time</th>
      <th style={styles.th}>Subject</th>
    </tr>
  </thead>
  <tbody>
    {bookings.map((b) => (
      <tr key={b.id}>
        <td style={styles.td}>{formatDate(b.date)}</td>
        <td style={styles.td}>{b.time}</td>
        <td style={styles.td}>{b.subject}</td>
      </tr>
    ))}
  </tbody>
</table>

            )}
          </div>

     <div style={styles.card}>
  <h2 style={styles.progressTitle}>📊 Your Progress</h2>

  <div style={styles.progressBlock}>
    <h3 style={styles.sectionTitle}>🖐️ 5-a-Day</h3>
    <div style={styles.metricRow}>
      <span style={styles.metricIcon}>✅</span>
      <span style={styles.metricText}>Sets completed:</span>
      <strong style={styles.metricValue}>{completedSets}</strong>
    </div>
    <div style={styles.metricRow}>
      <span style={styles.metricIcon}>📈</span>
      <span style={styles.metricText}>Average score:</span>
      <strong style={styles.metricValue}>{averageScore}%</strong>
    </div>
    <div style={styles.metricRow}>
      <span style={styles.metricIcon}>🔥</span>
      <span style={styles.metricText}>Streak:</span>
      <strong style={styles.metricValue}>{calculateStreak()} days in a row</strong>
    </div>
  </div>

  <hr style={styles.sectionDivider} />

  <div style={styles.progressBlock}>
    <h3 style={styles.sectionTitle}>📘 Assignments</h3>
    <div style={styles.metricRow}>
      <span style={styles.metricIcon}>📚</span>
      <span style={styles.metricText}>Assignments completed:</span>
      <strong style={styles.metricValue}>{assignments.length}</strong>
    </div>
  </div>
</div>






          <div style={{ ...styles.card, backgroundColor: "#fef6e4" }}>
            <h2>🖐️ 5-a-Day Practice</h2>
            <div style={styles.dateText}>
              {getCurrentDayAndDate()}
            </div>
            {fiveADay.length === 0 ? (
              <p>Generating questions...</p>
            ) : (
              <div>
                {fiveADay.map((q, i) => (
                  <div key={q.id} style={styles.questionBox}>
                    <div style={{ fontSize: "1.4rem", marginBottom: "0.6rem" }}>
  <Latex>{q.textLines?.[0] || q.questionText }</Latex>
</div>

                   <div style={{ fontSize: "1.2rem", marginBottom: "0.5rem" }}>
  {q.questionLatex ? (
    <Latex>{`$${q.questionLatex}$`}</Latex>
  ) : q.textLines?.[1] ? (
    <Latex>{`$${q.textLines[1]}$`}</Latex>
  ) : (
    <em>No equation provided</em>
  )}

  {/* Render optional suffix if it exists */}
  {q.optionalQuestionText && (
    <div style={{ marginTop: "0.5rem", fontSize: "1.3rem" }}>
      <Latex>{q.optionalQuestionText}</Latex>
    </div>
  )}
</div>

                    {!isASLevel && (
  <div>
    {q.calculatorAllowed ? (
      <img src="/assets/calculator.png" alt="Calculator Allowed" style={styles.icon} />
    ) : (
      <img src="/assets/no-calculator.png" alt="No Calculator Allowed" style={styles.icon} />
    )}
  </div>
)}

                    <div style={styles.answerRow}>
  {q.answerPrefix && (
    <Latex style={styles.answerPrefix}>{`$${q.answerPrefix}$`}</Latex>

  )}
  <math-field
    style={styles.mathInput}
    value={studentAnswers[i]}
    onInput={(e) => handleInput(e.target.value, i)}
    disabled={disabled[i]}
  />
</div>

                    <div style={{ marginTop: "0.5rem" }}>
                      <button style={styles.checkBtn} onClick={() => checkAnswer(i)} disabled={disabled[i]}>
                        Check Answer
                      </button>
                    </div>

                   {feedback[i] && (
  typeof feedback[i] === "string" && feedback[i] === "✅ Correct!" ? (
    <div style={styles.correctRow}>
      <svg viewBox="0 0 24 24" style={styles.tickIcon}>
        <path d="M9 16.2l-3.5-3.5-1.4 1.4L9 19 20 8l-1.4-1.4z" />
      </svg>
      <span style={styles.correctText}>Correct!</span>
    </div>
  ) : typeof feedback[i] === "string" ? (
    <div style={styles.tryAgainRow}>
      <svg viewBox="0 0 24 24" style={styles.crossIcon}>
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10
                 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
      </svg>
      <span style={styles.tryAgainText}>{feedback[i]}</span>
    </div>
  ) : (
    <div style={styles.incorrectRow}>
      <svg viewBox="0 0 24 24" style={styles.crossIcon}>
        <path d="M18.364 5.636l-1.414-1.414L12 9.172 
                 7.05 4.222 5.636 5.636 10.586 10.586 
                 5.636 15.536l1.414 1.414L12 12.828l4.95 
                 4.95 1.414-1.414L13.414 10.586z" />
      </svg>
      <span style={styles.incorrectText}>
        Incorrect. Correct answer: <Latex>{`$${feedback[i].latex}$`}</Latex>
      </span>
    </div>
  )
)}


                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </StudentLayout>
  );
}

const styles = {
  container: {
    padding: "2rem",
    fontFamily: "'Fredoka', cursive",
    backgroundColor: "#f0f8ff",
    minHeight: "100vh",
  },
  welcome: {
    fontSize: "2.2rem",
    fontWeight: "bold",
    marginBottom: "0.5rem",
    color: "#2c3e50",
  },
  subtext: {
    fontSize: "1.1rem",
    color: "#555",
    marginBottom: "2rem",
  },
  dateText: {
    fontSize: "1rem",
    fontWeight: "bold",
    marginBottom: "0.5rem",
    color: "#555",
  },
  sections: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "1.5rem",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "1.5rem",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  },
  listItem: {
    marginBottom: "0.6rem",
    fontSize: "1rem",
  },
  loading: {
    fontFamily: "'Patrick Hand', cursive",
    fontSize: "1.5rem",
    color: "#333",
    paddingTop: "5rem",
    textAlign: "center",
  },
  questionBox: {
    backgroundColor: "#d6ecff",
    padding: "1rem",
    borderRadius: "10px",
    border: "2px solid #8ac6ff",
    marginBottom: "1rem",
  },
  mathInput: {
    width: "100%",
    minHeight: "40px",
    fontSize: "1.2rem",
    borderRadius: "8px",
    border: "1px solid #ccc",
    padding: "0.5rem",
  },
  checkBtn: {
    padding: "0.5rem 1rem",
    backgroundColor: "#0984e3",
    color: "white",
    fontWeight: "bold",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
  feedback: {
    marginTop: "0.5rem",
    fontSize: "1rem",
  },
  icon: {
    width: "30px",
    marginLeft: "10px",
  },
  answerRow: {
  display: "flex",
  alignItems: "center",
  marginBottom: "0.5rem",
  gap: "0.5rem",
},

answerPrefix: {
  fontSize: "1.2rem",
  fontWeight: "bold",
  whiteSpace: "nowrap",
},
correctRow: {
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  fontSize: "1.1rem",
},

tickIcon: {
  width: "26px",
  height: "26px",
  fill: "#2ecc71",
  animation: "pop 0.3s ease-out",
},

correctText: {
  fontWeight: "600",
  color: "#2ecc71",
},
incorrectRow: {
  display: "flex",
  alignItems: "center",
  gap: "0.6rem",
  color: "#c0392b",
  fontSize: "1.05rem",
},

crossIcon: {
  width: "24px",
  height: "24px",
  fill: "#e74c3c",
},

incorrectText: {
  color: "#c0392b",
  fontWeight: "500",
},

tryAgainRow: {
  display: "flex",
  alignItems: "center",
  gap: "0.6rem",
  color: "#d35400",
  fontSize: "1rem",
},

tryAgainText: {
  fontWeight: "500",
  color: "#d35400",
},
table: {
  width: "100%",
  borderCollapse: "collapse",
  marginTop: "1rem",
},
th: {
  textAlign: "left",
  borderBottom: "2px solid #ccc",
  padding: "0.5rem",
  fontWeight: "bold",
  backgroundColor: "#f5f5f5",
},
td: {
  padding: "0.5rem",
  borderBottom: "1px solid #eee",
},
progressItem: {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  fontSize: "1.3rem", // increased from 1.1rem
  marginBottom: "0.8rem",
  padding: "0.6rem 0",
  borderBottom: "1px solid #eee",
},

progressIcon: {
  marginRight: "0.6rem",
  fontSize: "1.6rem", // slightly larger icons
},

progressValue: {
  fontWeight: "bold",
  color: "#2d98da",
  fontSize: "1.5rem", // increased from 1.2rem
},

progressSection: {
  marginBottom: "1rem",
},

subheading: {
  fontSize: "1.1rem",
  fontWeight: "600",
  marginBottom: "0.3rem",
  color: "#2c3e50",
},

divider: {
  borderTop: "1px solid #ccc",
  margin: "1rem 0",
},
progressTitle: {
  fontSize: "1.7rem",
  marginBottom: "1rem",
  color: "#333",
},

progressBlock: {
  marginBottom: "1rem",
},

sectionTitle: {
  fontSize: "1.3rem",
  marginBottom: "0.6rem",
  color: "#1d3557",
  fontWeight: "600",
},

metricRow: {
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  fontSize: "1.05rem",
  marginBottom: "0.4rem",
},

metricIcon: {
  fontSize: "1.2rem",
},

metricText: {
  flexGrow: 1,
  color: "#333",
},

metricValue: {
  fontWeight: "600",
  color: "#2d6a4f",
},

sectionDivider: {
  border: "none",
  borderTop: "1.5px solid black", // 🔥 Make the line black
  margin: "1rem 0",
},


};

export default StudentDashboard;
